import * as api from "../../api";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Link, useHistory } from "react-router-dom";

import Head from "../../components/Head/Head";
import NavBar from "../../components/NavBar/NavBar";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

import Langs from "../../data/translation";

import Translator from "../../images/comic-translator.png";
import Translate from "../../images/hand-translation.png";

import { ALERT } from "../../constants/actionTypes";

import {
  Check,
  CompareArrows,
  FileCopyOutlined,
  InfoOutlined,
  KeyboardArrowDown,
} from "@material-ui/icons";

import "./Translation.css";

const Translation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [source, setSource] = useState("Automatic");
  const [target, setTarget] = useState("Spanish");
  const [regexSource, setRegexSource] = useState(".");
  const [regexTarget, setRegexTarget] = useState(".");
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [translation, setTranslation] = useState("Your translation goes here");

  const newRegexSource = new RegExp(regexSource, "i");
  const newRegexTarget = new RegExp(regexTarget, "i");

  const languageSource = Langs.filter((lang) => newRegexSource.test(lang));
  const languageTarget = Langs.filter((lang) => newRegexTarget.test(lang));

  const handleDropdownSelect = (type, value) => {
    if (type === "source") {
      setSource(value);
      document.querySelector("#details__source").removeAttribute("open");
    } else {
      setTarget(value);
      document.querySelector("#details__target").removeAttribute("open");
    }
  };

  const copyTranslationToClipboard = () => {
    const text = document.querySelector("#translation__copy").innerText;
    navigator.clipboard.writeText(text);
    document.querySelector(".translation__copied__text").style.display =
      "block";

    setTimeout(() => {
      document.querySelector(".translation__copied__text").style.display =
        "none";
    }, 200);
  };

  const handleTranslate = async () => {
    setLoading(true);

    try {
      if (content.trim() !== "") {
        const { data } = await api.translate({
          text: content,
          from: source,
          to: target,
        });

        setTranslation(data.translation);
      }
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setLoading(false);
    }
  };

  const summaryStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    listStyle: "none",
  };

  return (
    <>
      <NavBar online />
      <Head
        title={"Oneconverse online translation"}
        description={
          "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
        }
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />

      <div className="online__translation">
        <div className="container online__translation__body">
          <h2 className="font-subhead py-20 text-center">
            Free Translation Online
          </h2>
          <p className="pb-10 font-big font-heavy text-center">
            OneConverse Online Translation provides free translations from any
            language into English or vice versa for your convenience, our free
            online translator offers quick and accurate translations right at
            your fingertips. Simply type in the word or phrase that you want
            translated.
          </p>
          <div className="mx-auto my-40 w-100">
            <div className="online__translation__info d-flex align-center py-10 mx-auto">
              <InfoOutlined className="icon-blue mr-5" fontSize="small" />
              Maximum of 1000 characters allowed for supported languages in the
              dropdown.
            </div>
            <div className="online__translation__box d-flex f-100 mx-auto rounded">
              <div className="online__translation__box__left f-50 position-relative p-20">
                <div className="d-flex justify-between align-center w-100">
                  <details id="details__source" className="w-100">
                    <summary
                      style={summaryStyle}
                      className="list-none d-flex align-center justify-between font-bold p-10 border-1 rounded text-capitalise w-100"
                    >
                      <span>{source}</span>
                      <KeyboardArrowDown />
                    </summary>
                    <div className="border-1 z-4 position-absolute">
                      <input
                        type="text"
                        className="w-100 p-10 border-0 outline-0 border-bottom-1"
                        placeholder="Search..."
                        onChange={(e) => setRegexSource(e.target.content)}
                      />
                      <ul className="list-none w-100 overflow-auto">
                        {languageSource.sort().map((lang) => (
                          <li
                            key={lang}
                            style={{ color: source === lang ? "#ff5e15" : "" }}
                            className="d-flex align-center justify-between p-10 border-bottom-1 pointer text-capitalise"
                            onClick={(e) =>
                              handleDropdownSelect("source", lang)
                            }
                          >
                            {lang}
                            {source === lang && <Check />}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </details>

                  <div className="online__translation__big">
                    <CompareArrows
                      fontSize="large"
                      className="icon-light-grey mx-40"
                    />
                  </div>

                  <details
                    id="details__target"
                    className="online__translation__big w-100"
                  >
                    <summary className="list-none d-flex align-center justify-between font-bold p-10 border-1 rounded text-capitalise w-100">
                      <span>{target}</span>
                      <KeyboardArrowDown />
                    </summary>
                    <div className="border-1 position-absolute z-4">
                      <input
                        type="text"
                        className="w-100 p-10 border-0 outline-0 border-bottom-1"
                        placeholder="Search..."
                        onChange={(e) => setRegexTarget(e.target.value)}
                      />
                      <ul className="list-none w-100 overflow-auto">
                        {languageTarget
                          .filter((lang) => lang !== "Automatic")
                          .sort()
                          .map((lang) => (
                            <li
                              key={lang}
                              style={{
                                color: target === lang ? "#ff5e15" : "",
                              }}
                              className="d-flex align-center justify-between p-10 border-bottom-1 pointer text-capitalise"
                              onClick={(e) =>
                                handleDropdownSelect("target", lang)
                              }
                            >
                              {lang}
                              {target === lang && <Check />}
                            </li>
                          ))}
                      </ul>
                    </div>
                  </details>
                </div>
                <textarea
                  placeholder="Start typing here"
                  maxLength="1000"
                  className="border-0 outline-0 py-20 w-100 h-100"
                  onChange={(e) => setContent(e.target.value)}
                />
              </div>
              <div className="online__translation__box__right f-50 p-20 position-relative">
                <div className="d-flex justify-between align-center w-100">
                  <button
                    className="font-bold p-10 mr-20 border-0 outline-0 rounded text-capitalise w-100"
                    onClick={handleTranslate}
                  >
                    Online Translation
                  </button>

                  <button
                    className="online__translation__big font-bold p-10 ml-20 border-0 outline-0 rounded text-capitalise w-100"
                    onClick={() => history.push("/quote")}
                  >
                    Professional Translation
                  </button>
                </div>
                <div className="py-20 w-100 h-100 position-relative">
                  <div className="d-flex justify-between align-center w-100">
                    <details
                      id="details__target"
                      className="online__translation__sm w-100 pb-20"
                    >
                      <summary
                        style={summaryStyle}
                        className="list-none d-flex align-center justify-between font-bold p-10 border-1 rounded text-capitalise w-100"
                      >
                        <span>{target}</span>
                        <KeyboardArrowDown />
                      </summary>
                      <div className="border-1 position-absolute z-4">
                        <input
                          type="text"
                          className="w-100 p-10 border-0 outline-0 border-bottom-1"
                          placeholder="Search..."
                          onChange={(e) => setRegexTarget(e.target.value)}
                        />
                        <ul className="list-none w-100 overflow-auto">
                          {languageTarget
                            .filter((lang) => lang !== "Automatic")
                            .sort()
                            .map((lang) => (
                              <li
                                key={lang}
                                style={{
                                  color: target === lang ? "#ff5e15" : "",
                                }}
                                className="d-flex align-center justify-between p-10 border-bottom-1 pointer text-capitalise"
                                onClick={(e) =>
                                  handleDropdownSelect("target", lang)
                                }
                              >
                                {lang}
                                {target === lang && <Check />}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </details>
                  </div>
                  <div
                    id="translation__copy"
                    className="online__translation__translated overflow-auto"
                  >
                    {loading ? "Loading..." : translation}
                  </div>
                  <div
                    title="Copy"
                    className="position-absolute d-flex align-center r-0 b-0 mb-40"
                  >
                    <span
                      style={{ display: "none" }}
                      className="translation__copied__text font-big font-heavy mr-10"
                    >
                      Copied!
                    </span>
                    <FileCopyOutlined
                      className="icon-blue pointer"
                      onClick={copyTranslationToClipboard}
                    />
                  </div>
                </div>
              </div>
            </div>

            <button
              className="online__translation__sm online__translation__human font-bold p-10 border-0 outline-0 rounded text-capitalise w-100 my-20"
              onClick={() => history.push("/quote")}
            >
              Professional Translation
            </button>
          </div>
          <p className="online__translation__warning mx-auto font-big font-heavy text-left py-20">
            The accuracy of this translation can not be ascertained,{" "}
            <Link to="/quote" className="font-bolder">
              click here
            </Link>{" "}
            to request a professional translation with perfect accuracy
          </p>
          <div className="translation__sections py-40">
            <h2 className="text-center font-subhead py-40">
              Why You Should Go For A Professional Translation?
            </h2>
            <div className="online__translation__section d-flex flex-row-reverse justify-between align-center f-100">
              <div className="f-50 font-heavy">
                <p className="py-5">
                  If you are looking to translate something, whether it is a
                  website or an article, OneConverse professional translation
                  will provide the best results. OneConverse Professional
                  translators know which words and phrases to use for people who
                  speak other languages to understand what you mean. It will be
                  much easier for people who do not speak your language to read
                  anything that has been translated by someone who knows what
                  they're doing than if you just did it yourself without any
                  prior knowledge of the language.
                </p>
                <p className="py-5">
                  It is a common misconception that you can get by with using
                  Online Translate for all your document translations. While it
                  may be convenient, there are many reasons why you should never
                  use it again once you have been exposed to the superior
                  quality of OneConverse professional translators. In this
                  article we will discuss five ways that online translate falls
                  short and how hiring a OneConverse professional translator can
                  help improve your business outcomes.
                </p>
                <p className="py-5">
                  The first thing people think about when they hear the word
                  "translation" is often a language barrier between two
                  different countries speaking different languages. However, in
                  today's globalized economy, English has become an
                  international standard and more companies are doing their
                  business across borders than ever before. This means that the
                  need for translation services has increased exponentially over
                  recent years. Not all translations are created equal.
                </p>
                <p className="py-5">
                  Oneconverse Professional translators have undergone years of
                  training and education to ensure that the translation is both
                  accurate and easy for a native speaker to understand. If you
                  want your message to be understood in another language, then
                  hiring a professional translator is essential. Language
                  barriers exist everywhere in our lives, whether it's at work
                  or in school or even just when travelling abroad. Translations
                  can help break down these barriers so that everyone feels
                  included in important conversations.
                </p>
              </div>
              <div className="d-flex justify-start f-50 position-relative">
                <img src={Translate} alt="" />
              </div>
            </div>
          </div>
          <div className="translation__sections py-40">
            <h2 className="text-center font-subhead py-40">
              Why Choose Us For Your Professional Translation?
            </h2>
            <div className="online__translation__section d-flex justify-between align-center f-100">
              <div className="f-50 font-heavy">
                <p className="py-5">
                  OneConverse is a translation company that can translate any
                  document into more than 300 languages. They are one of the
                  most reliable translators in the industry because they have
                  been around for over 10 years, and they are always on top of
                  current trends. OneConverse has an easy-to-use website that
                  makes it simple to upload your documents for translation
                  without having to go through complicated steps or fill out
                  lengthy forms.
                </p>
                <p className="py-5">
                  OneConverse Translator is a web-based application that allows
                  you to translate documents, without the need for any
                  additional software. This online tool makes it easy to get
                  started with translation in just minutes. With this service,
                  you can easily send files from your computer or directly
                  upload them from Google Drive, Dropbox and Box. OneConverse
                  Translator is simple enough for beginners but also provides
                  advanced tools when necessary.
                </p>
                <p className="py-5">
                  Whether you are a business owner or an individual trying to
                  learn another language, choosing the right translation
                  services provider can be a challenge. Oneconverse Translator
                  provides all your document translations needs with high
                  quality work and excellent customer service. We take pride in
                  our ability to make sure that every client is satisfied with
                  their documents translated by us.
                </p>
                <p className="py-5">
                  Whether it's providing quick turnaround times or using only
                  professional translators, we will go above and beyond for you!
                  Oneconverse Translator specializes in document translations of
                  all kinds including personal statements, legal agreements,
                  school transcripts and medical records among many others. Our
                  experienced team will help you choose the best option that
                  suits your specific situation whether it's having them
                  translated into multiple languages or just one depending on
                  the what you need
                </p>
              </div>
              <div className="d-flex justify-end f-50 position-relative">
                <img src={Translator} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <InstantQuote />
      </div>
      <ContactUs />
      <Footer />
    </>
  );
};

export default Translation;
